import { type StoreActionApi } from 'react-sweet-state';

import { type Source } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import type { ChatMessageResearchStore } from './types';
import { updateStep } from './updateStep';

type SetStepSourcesArgs = { messageId: string; stepId: string; sources: Source[] };

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const setStepSources: (args: SetStepSourcesArgs) => ChatMessageResearchStoreAction =
	({ messageId, stepId, sources }) =>
	({ dispatch }: StoreActionApi<ChatMessageResearchStore>) => {
		dispatch(updateStep({ messageId, stepId, updater: (step) => ({ ...step, sources }) }));
	};
